<template>
    <div class="evidence">
        <el-dialog title="打款凭证" :visible.sync="dialogTableVisible" width="400px">
            <div class="evidenceImg">
                <el-image
                    style="width: 100px; height: 100px;margin-right:15px; margin-bottom: 15px;"
                    v-for="(items,index) in srcList" :key="index"
                    :src="items"
                    :preview-src-list="srcList">
                </el-image>
            </div>
            <div class="evidenceBtn">
                <el-button @click="dialogTableVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmOfflinePay">确认</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
    import {
        getOfflinePayTicket
    } from '../../utils/interface';
    export default {
        data() {
            return {
                dialogTableVisible: false,
                srcList: [
                ]
            };
        },
        methods: {
            init(order){
                this.srcList = [];
                this.offlinePayTicket(order);
                this.dialogTableVisible = true
            },
            close(){
                this.dialogTableVisible = false;
            },
            offlinePayTicket(order){
                getOfflinePayTicket(order.orderBase.orderNo).then(res=> {
                    if (res && res.success) {
                        this.srcList.push(res.data.payTicket)
                    }else {
                        this.$message.error(res.message);
                    }
                });
            },
            confirmOfflinePay(){
                this.$emit('offlinePay');
            }
        }
    };
</script>

<style lang="less" scoped>
    .evidence {
        .evidenceImg {
            display: flex;
            flex-wrap: wrap;
        }
        .evidenceBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 30px;
            button {
                margin-right: 16px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/evidence/evidence.vue